/**
 * Computes the default shipping fee from Payable To shipping charge rules.
 *
 * @param {number} subtotal - Product subtotal (excluding shipping/tax/order discount)
 * @param {{ minimum?: number|null, amount?: number|null }|null|undefined} shippingCharge
 * @param {{ isSample?: boolean }} [options]
 * @returns {number}
 */
export function computePayableToShippingFee(
  subtotal,
  shippingCharge,
  { isSample = false } = {},
) {
  if (isSample) {
    return 0;
  }

  const minimum = Number(shippingCharge?.minimum) || 0;
  const amount = Number(shippingCharge?.amount) || 0;
  const normalizedSubtotal = Number(subtotal) || 0;

  if (minimum <= 0 || normalizedSubtotal <= 0) {
    return 0;
  }

  return normalizedSubtotal < minimum ? amount : 0;
}
